// Description: Constants used to map statuses from user org statuses API call to table progress bars.
export const adRequestStatusMap = {
  "Not-Requested": "Non-Member",
  Requested: "In-Progress",
  Joined: "Joined",
  Failed: "Failed",
  Pending: "Pending",
  Rejected: "Rejected",
  "Remove-Requested": "Removed",
  Removed: "Removed",
};

export const TOKEN_VALIDITY_DAYS_UPPER_LIMIT = 360;
export const TOKEN_VALIDITY_DAYS_LOWER_LIMIT = 90;
export const TOKEN_VALIDITY_DAYS_DEFAULT = 180;

export const TOKEN_INACTIVITY_DAYS_UPPER_LIMIT = 90;
export const TOKEN_INACTIVITY_DAYS_LOWER_LIMIT = 30;
export const TOKEN_INACTIVITY_DAYS_DEFAULT = 45;

export const SIGNUP_BANNER_DEFAULT = "No description available";

export const REASON_COLUMN_CHARACTER_TRUNCATE_LIMIT = 50;
export const EMAIL_COLUMN_CHARACTER_TRUNCATE_LIMIT_OWNER_VIEW = 28;
export const EMAIL_COLUMN_CHARACTER_TRUNCATE_LIMIT_APPROVER_VIEW = 35;

// Session lifecycle: a hard ceiling on how long a session may last since
// login, independent of mouse/keyboard activity and independent of whether
// Azure AD would otherwise keep silently renewing the token forever. Chosen
// to match Azure AD's typical ~1hr default ID token lifetime; the app warns
// SESSION_WARNING_BEFORE_EXPIRY_MS before this and force-logs-out at it.
export const SESSION_DURATION_MS = 60 * 60 * 1000; // 1 hour
export const SESSION_WARNING_BEFORE_EXPIRY_MS = 5 * 60 * 1000; // 5 minutes

// MSAL's silent call can hand back a cached ID token that is about to expire
// (it only looks at the cached *access* token's expiry). When the ID token
// has less than this left, one extra forced refresh is made so the API never
// receives a token that dies mid-request. Set to 0 to switch this off.
export const ID_TOKEN_REFRESH_BEFORE_EXPIRY_MS = 2 * 60 * 1000; // 2 minutes

// How often the signed-in user's roles/permissions are re-fetched in the
// background, so a role change made by an admin elsewhere is caught within a
// bounded window even if the signed-in user never triggers another API call
// themselves. 5 minutes matches the existing session-expiry-warning window
// above — permission changes don't need sub-minute reaction time, and
// polling more aggressively than that mostly just adds steady-state load on
// the auth service for no real benefit. This is the sole re-check mechanism
// for useGetUserAccessQuery — refetchOnFocus is deliberately NOT used there
// (see useAccessPermissions.js) since it fires on window focus/
// visibilitychange, which MUI's portaled components can trigger on ordinary
// in-page clicks, not just real tab/window switches.
export const PERMISSIONS_POLL_INTERVAL_MS = 5 * 60 * 1000;

// Temporary kill switch for all new join requests/adds; set to false to re-enable signups
export const SIGNUPS_TEMPORARILY_DISABLED = false;
export const SIGNUPS_DISABLED_TOOLTIP =
  "Temporarily disabled due to an ongoing issue with GitHub. New joining requests will be enabled shortly.";

// sessionStorage key remembering that the user dismissed the signups-paused modal this session.
export const SIGNUPS_PAUSED_DISMISSED_KEY = "signupsPausedModalDismissed";
